import { useCallback, useState } from 'react';
import createUseContext from 'constate';

const useProviderDetails = () => {
  const [providerDetails, setProviderDetails] = useState({});

  const addProviderDetails = useCallback(
    (key, data) => setProviderDetails((oldProviderDetails) => ({
      ...oldProviderDetails,
      [key]: data,
    })),
    []
  );

  return {
    providerDetails,
    addProviderDetails,
  };
};

const [ProviderDetailsProvider, useProviderDetailsContext] = createUseContext(useProviderDetails);

export {
  ProviderDetailsProvider,
  useProviderDetailsContext,
};
